import { Application } from "@hotwired/stimulus"

// Start the Stimulus application. Controllers are registered by hand here as
// they're added (no auto-loader). Each webpack entry that imports this module
// gets its own Application instance (entries are bundled separately).
const application = Application.start()

export default application
